import React from "react";
import { useChains, chainTypeLabel } from "@/lib/chains";

export default function Networks() {
  const chains = useChains();
  return (
    <section id="networks" className="mt-12 sm:mt-16">
      <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-4 gap-2">
        <div>
          <div className="text-[10.5px] uppercase tracking-[0.28em] text-[var(--accent)] font-semibold">Supported networks</div>
          <h2 className="text-[18px] sm:text-[22px] font-semibold text-[var(--text)] mt-1">Every major chain, one interface.</h2>
        </div>
        <span className="text-[11px] text-[var(--text-muted)] font-mono" data-testid="networks-count">
          {chains ? `${chains.length} networks` : "…"} · one aggregator
        </span>
      </div>
      <div className="panel p-2">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10">
          {(chains || []).map((c) => (
            <div key={`${c.chainType}-${c.id}`} className="flex flex-col items-center gap-2 p-3 sm:p-4 border-r border-b border-[var(--border)] last:border-r-0">
              <img src={c.icon} alt={c.name} className="w-8 h-8 rounded-full bg-[var(--panel-2)]" onError={(e) => (e.currentTarget.style.display = "none")} />
              <div className="text-[11.5px] sm:text-[12px] text-[var(--text)] font-medium truncate max-w-full">{c.name}</div>
              <div className="text-[10px] text-[var(--text-subtle)] font-mono uppercase tracking-wider">
                {chainTypeLabel(c)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
